import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LogContext from './context/LogContext';
import emptyCart from './media/102661.png';

import greenPulse from './media/Green Pulse Dot.webm';
import CouponBlock from './components/ui/CouponBlock';
import Checkout from './components/Checkout';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL; // ✅ works

export default function Cart() {
  const myContext = useContext(LogContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState();
  const [products, setProducts] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalValue, setTotalValue] = useState();
  const [bagDiscount, setBagDiscount] = useState();
  const [selectedCoupon, setSelectedCoupon] = useState();
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [isCheckout, setIsCheckout] = useState(false);

  const cartUpdate = async () => {
    try {
      const response = await fetch(`${backendUrl}/cartData`, {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ email: email })
      });
      if (response.ok) {
        const productArray = await response.json();
        setProducts(productArray.cartItems.map((product) => (product)));
      } else {
        console.log("Can't retrieve data from the user collections in the database");
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  }
  const decreaseButtonHandler = async (productID, quantity) => {
    try {
      const response = await fetch(`${backendUrl}/itemQuantityHandler`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ productID, email, "function": "decrease", quantity })
      });
      if (response.ok) {
        // Refresh cart after updating quantity
        cartUpdate();
      } else {
        console.log("Unsuccessful request");
      }
    } catch (error) {
      console.error("Error in increaseButtonHandler:", error);
    }
  }
  const increaseButtonHandler = async (productID, quantity) => {
    try {
      const response = await fetch(`${backendUrl}/itemQuantityHandler`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ productID, email, "function": "increase", quantity })
      });
      if (response.ok) {
        // Refresh cart after updating quantity
        cartUpdate();
      } else {
        console.log("Unsuccessful request");
      }
    } catch (error) {
      console.error("Error in increaseButtonHandler:", error);
    }
  }
  const handleBuy = () => {
    localStorage.setItem('from', 'cart');
    setIsCheckout(true);
    window.scrollTo({ top: 1, behavior: 'smooth' });
  }
  useEffect(() => {
    if (myContext.user) {
      setEmail(myContext.user.email);
    }
  }, [myContext.user]);

  useEffect(() => {
    if (email !== undefined) {
      cartUpdate();
    }
  }, [email]);

  useEffect(() => {
    if (selectedCoupon) {
      myContext.updateCoupon(selectedCoupon);
      const discount = (selectedCoupon.discountType === 'fixed') ? selectedCoupon.discountValue : (totalValue - bagDiscount) * (selectedCoupon.discountValue / 100);
      setCouponDiscount(discount);
    }
  }, [selectedCoupon])

  function sum(total, element) {
    return total + (parseFloat(element.quantity)) * (parseFloat(element.pricing.MRP))
  }
  function sumBagDiscount(total, element) {
    return total + (parseFloat(element.quantity)) * (parseFloat(element.pricing.MRP) - parseFloat(element.pricing.offerPrice))
  }
  useEffect(() => {
    myContext.updateCart(products);
    const totalValue = products.reduce(sum, 0);
    const totalQuantity = products.reduce((sum, product) => sum + Number(product.quantity), 0);
    const bagDiscount = products.reduce(sumBagDiscount, 0);
    setTotalValue(totalValue);
    setTotalQuantity(totalQuantity);
    setBagDiscount(bagDiscount)
  }, [products]);

  return (
    <>
      {isCheckout ?
        <Checkout selectedCoupon={selectedCoupon} isCheckout={isCheckout} setIsCheckout={setIsCheckout} />
        :
        <div className='cart'>
          <div className='head'>Shopping Bag</div>
          <div className='product-container row'>
            <div id='carting' className='col-md-8 col-sm-12'>
              {products.length === 0 ? (
                <div className='text-center emptycart-container' style={{ marginTop: '2rem' }}>
                  <p className='head'>Cart is empty</p>
                  <img className="empty-cart" src={emptyCart} alt="" />
                </div>
              ) : (
                products.map((product) => (
                  <div key={product._id} className='product' style={{ display: 'flex' }}>
                    <div className='col-4'>
                      <img className="image" src={`${adminUrl}/uploads/products/${product.images[0].preview}`} alt='' />
                      <div className=''>
                        {window.innerWidth < 567 && <p className='button' style={{ display: 'flex' }}>
                          <button className='btn' onClick={() => decreaseButtonHandler(product._id, product.quantity)}>-</button>
                          <button className='btn-cart'>{product.quantity}</button>
                          <button className='btn' onClick={() => increaseButtonHandler(product._id, product.quantity)}>+</button>
                        </p>}
                      </div>
                    </div>
                    <div className='col-8 details'>
                      <div className='pName'>{product.title} {window.innerWidth > 576 && <span className='price pull-right'>&#8377; {product.pricing.offerPrice}</span>}</div>
                      {window.innerWidth < 576 && <p className='price'>₹ {product.pricing.offerPrice}</p>}
                      <p className="stock" style={{ display: 'flex', alignItems: 'center', gap: '0.1rem' }}>
                        <video autoPlay muted loop playsInline style={{ width: '35px' }}>
                          <source src={greenPulse} type="video/webm" />
                          Your browser does not support the video tag.
                        </video>
                        <span>Instock</span>
                      </p>

                      <p className='sold-by'>Color : <strong>&nbsp;{product.additionalInfo.color}</strong></p>
                      <p className='deliver-by'>Size: <strong>&nbsp;{'Small'}</strong></p>
                      {window.innerWidth > 576 && <p className='button' style={{ display: 'flex' }}>
                        <button className='btn' onClick={() => decreaseButtonHandler(product._id, product.quantity)}>-</button>
                        <button className='btn-cart'>{product.quantity}</button>
                        <button className='btn' onClick={() => increaseButtonHandler(product._id, product.quantity)}>+</button>
                      </p>}
                    </div>
                  </div>
                ))
              )}
            </div>
            <div className='col-md-4 col-sm-12'>
              {products.length !== 0 &&

                <>
                  <CouponBlock setSelectedCoupon={setSelectedCoupon} />
                  <div className='buy-cart'>
                    <div style={{ width: '100%' }}>
                      <div className="d-flex justify-content-between mb-2 st-row">
                        <span>Subtotal ({totalQuantity} {totalQuantity == 1 ? 'Item' : 'Items'})</span>
                        <span className="pull-right">₹{totalValue}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2 st-row">
                        <span>Bag Discount</span>
                        <span className="pull-right text-danger">- ₹{bagDiscount}</span>
                      </div>
                      {selectedCoupon && <div className="d-flex justify-content-between mb-2 st-row">
                        <span>Coupon Discount</span>
                        <span className="pull-right text-danger">- ₹{couponDiscount}</span>
                      </div>}
                      <div className="d-flex justify-content-between mb-2 st-row">
                        <span>Shipping</span>
                        <span className="pull-right text-success">Free</span>
                      </div>
                      <div
                        className="d-flex justify-content-between mt-3 pt-2 fw-bold st-row"
                        style={{ borderTop: '1px solid #ccc', marginTop: '1rem', paddingTop: '1.5rem' }}
                      >
                        <span>Total</span>
                        <span className="pull-right">₹{totalValue - bagDiscount - couponDiscount}</span>
                      </div>
                    </div>


                    <button type="submit" className="btn button-submit" onClick={handleBuy}>Proceed to Buy</button>
                  </div>
                </>
              }

            </div>
          </div>
        </div>}
    </>
  );
}
